import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppointmentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Appointment",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26.12 16.69c-2.98 0-4.41 3.26-4.41 3.26s-1.42-3.26-4.41-3.26-4 2.92-4 4.41c0 2.98 2.85 7.12 8.41 9.9 5.56-2.78 8.41-6.92 8.41-9.9 0-1.5-1.02-4.41-4.01-4.41Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.37 23.22H5c-.36 0-.65-.29-.65-.65V7.34c0-.31.25-.56.56-.56h1.65v1.84c0 .68.55 1.24 1.24 1.24s1.24-.55 1.24-1.24V6.78h7.94v1.84c0 .68.55 1.24 1.24 1.24s1.24-.55 1.24-1.24V6.78h1.56c.36 0 .65.29.65.65v7.2c0 .32.26.57.57.57h1.33c.32 0 .57-.26.57-.57V6.49c0-1.2-.98-2.18-2.18-2.18h-2.51V2.23c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v2.08H9.03V2.23c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v2.08h-2.5c-1.21 0-2.19.98-2.19 2.18V23.5c0 1.21.98 2.19 2.19 2.19h7.31c.25 0 .45-.2.45-.45v-1.57c0-.25-.2-.45-.45-.45Z"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "6.13",
        y: "11.67",
        rx: ".9",
        ry: ".9"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "6.13",
        y: "16.33",
        rx: ".9",
        ry: ".9"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "11.18",
        y: "11.67",
        rx: ".9",
        ry: ".9"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "16.23",
        y: "11.67",
        rx: ".9",
        ry: ".9"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25 28h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3h17c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1V9c0-1.65 1.35-3 3-3h18c1.65 0 3 1.35 3 3v16c0 1.65-1.35 3-3 3"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11 10c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M21 10c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M10.65 28c-.25 0-.5-.09-.69-.28l-4.87-4.64c-.7-.66-1.1-1.6-1.1-2.56 0-1.95 1.59-3.53 3.53-3.53h.33c.94 0 1.83.37 2.5 1.03l.3.3.3-.3c.67-.67 1.56-1.04 2.5-1.04h.33c1.95 0 3.53 1.59 3.53 3.53 0 .96-.4 1.89-1.1 2.56l-4.87 4.64c-.19.18-.44.28-.69.28Zm-4.17-6.36 4.18 3.98 4.18-3.98c.3-.29.48-.69.48-1.11 0-.85-.69-1.53-1.53-1.53h-.33c-.41 0-.79.16-1.08.45l-1 1a.996.996 0 0 1-1.41 0l-1-1A1.53 1.53 0 0 0 7.89 19h-.33a1.53 1.53 0 0 0-1.05 2.64Z"
      })]
    })
  }));
};